export const DESKTOP_MIN_WIDTH = 1024;

export function isDesktopWebLayout(platformOs: string, width: number): boolean {
  return platformOs === "web" && width >= DESKTOP_MIN_WIDTH;
}

export const DESKTOP_SHEET_MAX_WIDTH = 600;

export function getDesktopSheetStyle(isDesktop: boolean) {
  return isDesktop
    ? ({
        width: "100%",
        maxWidth: DESKTOP_SHEET_MAX_WIDTH,
        marginLeft: "auto",
      } as const)
    : undefined;
}

export function matchesServiceQuery(
  service: { label: string; shortLabel?: string; description?: string },
  query: string,
): boolean {
  const normalized = query.trim().toLowerCase();
  if (normalized.length === 0) {
    return true;
  }

  return [service.label, service.shortLabel, service.description].some((value) =>
    value?.toLowerCase().includes(normalized),
  );
}

let serviceSearchQuery = "";
const searchListeners = new Set<() => void>();

export function getServiceSearchQuery(): string {
  return serviceSearchQuery;
}

export function setServiceSearchQuery(next: string): void {
  if (next === serviceSearchQuery) {
    return;
  }

  serviceSearchQuery = next;
  searchListeners.forEach((listener) => listener());
}

export function subscribeServiceSearch(listener: () => void): () => void {
  searchListeners.add(listener);
  return () => {
    searchListeners.delete(listener);
  };
}
